export default '/build/91d22183.svg'